
import http from './httpRequest.js'

class UserApi {}

UserApi.prototype.getAllUser = function() {
	return http({
		url: '/user/list',
		method: 'get',
    otherApis: true
	})
}

export default UserApi